const updateUsersLoading = (state, { payload: { loading } }) => {
	state.loading = loading;
};

export default updateUsersLoading;
